import { useState } from 'react';
import { Modal } from '../ui/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onCreate: (body: {
    company_name: string;
    email: string;
    password: string;
    full_name?: string;
    tron_payout_wallet?: string;
  }) => Promise<void>;
};

export function CargoCreateCompanyModal({ open, onClose, onCreate }: Props) {
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [wallet, setWallet] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setLoading(true);
    setError(null);
    try {
      await onCreate({
        company_name: companyName.trim(),
        email: email.trim(),
        password,
        full_name: fullName.trim() || undefined,
        tron_payout_wallet: wallet.trim() || undefined,
      });
      setCompanyName('');
      setEmail('');
      setPassword('');
      setFullName('');
      setWallet('');
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Create failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create cargo partner"
      open={open}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn-primary btn-inline" disabled={loading} onClick={() => void submit()}>
            {loading ? 'Creating…' : 'Create partner'}
          </button>
        </>
      }
    >
      {error ? <p className="form-error">{error}</p> : null}
      <div className="form-stack">
        <label className="field-label">
          Company name
          <input className="inp" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
        </label>
        <label className="field-label">
          Admin email
          <input className="inp" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field-label">
          Admin password
          <input className="inp" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <label className="field-label">
          Admin display name
          <input className="inp" value={fullName} onChange={(e) => setFullName(e.target.value)} />
        </label>
        <label className="field-label">
          Tron payout wallet (optional)
          <input className="inp" value={wallet} onChange={(e) => setWallet(e.target.value)} placeholder="T…" />
        </label>
      </div>
    </Modal>
  );
}
